import { createContext } from 'react';

interface StickyHeaderProps {
  isSticky: boolean;
}

export const StickyHeaderContext = createContext<StickyHeaderProps>({ isSticky: false });
